import React, {Component, useEffect, useRef, useState} from 'react';
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/es/connect/connect";
import {DataTable} from "primereact/datatable";
import {InputText} from 'primereact/inputtext';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {InputTextarea} from "primereact/inputtextarea";
import {Toast} from 'primereact/toast';
import {Dropdown} from "primereact/dropdown";
import {InputSwitch} from 'primereact/inputswitch';
import '../../css/style.css';
import {MultiSelect} from "primereact/multiselect";
import {Panel} from "primereact/panel";
import {InputNumber} from "primereact/inputnumber";
import axios from "axios";


const Inst_Dept = props => {

    const [institutions, setInstitutions] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [cities, setCities] = useState([]);
    const [countries, setCountries] = useState([]);
    const [personInstutions, setPersonInstutions] = useState([]);
    const [personInstID, setPersonInstID] = useState(null);


    const [dept_update_dialog_visible, setDeptUpdateDialogVisible] = useState(false);
    const [dept_update_btn_visible, setDeptUpdateBtnVisible] = useState(false);
    const [dept_add_btn_visible, setDeptAddBtnVisible,] = useState(false);
    const [inst_update_dialog_visible, setInstUpdateDialogVisible] = useState(false);
    const [inst_update_btn_visible, setInstUpdateBtnVisible] = useState(false);
    const [inst_add_btn_visible, setInstAddBtnVisible] = useState(false);

    const [dept_id, setDeptId] = useState(null);
    const [inst_id, setInstId] = useState(null);
    const [city_id, setCityId] = useState(null);
    const [coun_id, setCounId] = useState(null);

    const [dept_name, setDeptName] = useState('');
    const [dept_detail, setDeptDetail] = useState('');
    const [inst_name, setInstName] = useState('');
    const [inst_detail, setInstDetail] = useState('');
    const [departmentDisplay, setDepartmentDisplay] = useState('none');


    const inst_insert_type = 'INSERT_INSTITUTION';
    const delete_inst_type = 'DELETE_INSTITUTION';
    const update_inst_type = 'UPDATE_INSTITUTION';
    const inst_url = '/api/institutions/';
    const dept_insert_type = 'INSERT_DEPARTMENT';
    const delete_dept_type = 'DELETE_DEPARTMENT';
    const update_dept_type = 'UPDATE_DEPARTMENT';
    const dept_url = '/api/departments/';
    const inst_list_role = !!localStorage.getItem('inst_list');
    const toast = useRef(null);


    useEffect(() => {
        if (inst_list_role) {
            getAllInstitutions();
            getCities();
            getCountries();
            getPersonIntsution();
        }

    }, []);


    useEffect(() => {
        if (props.management.type === update_dept_type) {
            const management = props.management.management;
            if (management.result === 1) {
                //this.showSuccess(management.message);
                setDeptUpdateDialogVisible(false);
                setDeptUpdateBtnVisible(false);
                getDepartments(inst_id);
            } else {
                //this.showError(management.message);
            }
        }

        if (props.management.type === dept_insert_type) {
            const management = props.management.management;
            if (management.result === 1) {
                //this.showSuccess(management.message);
                setDeptUpdateDialogVisible(false);
                setDeptUpdateBtnVisible(false);
                getDepartments(this.state.inst_id);
            } else {
                //this.showError(management.message);
            }
        }

        if (props.management.type === delete_dept_type) {
            const management = props.management.management;
            if (management.result === 1) {
                // this.showSuccess(management.message);
                getDepartments(inst_id);
            } else {
                //this.showError(management.message);
            }
        }

        if (props.management.type === update_inst_type) {
            const management = props.management.management;
            if (management.result === 1) {
                //this.showSuccess(management.message);
                setInstUpdateDialogVisible(false);
                setInstUpdateBtnVisible(false);
                getAllInstitutions();
            } else {
                //this.showError(management.message);
            }
        }

        if (props.management.type === inst_insert_type) {
            const management = props.management.management;
            if (management.result === 1) {
                //this.showSuccess(management.message);
                setInstUpdateDialogVisible(false);
                setInstUpdateBtnVisible(false);
                getAllInstitutions();
            } else {
                //this.showError(management.message);
            }
        }

        if (props.management.type === delete_inst_type) {
            const management = props.management.management;
            if (management.result === 1) {
                //this.showSuccess(management.message);
                getAllInstitutions();
            } else {
                //this.showError(management.message);
            }
        }

    }, [props.management.type, props.management]);

    const getPersonIntsution = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/inst-person/", {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        console.log("---------------------", res.data.query_set_list)

                        setPersonInstutions(res.data.query_set_list);
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;
                    } else if (res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }
    const personInstutionsItems = personInstutions.map((item) => (
        {"label": item.pers_workinginstitute, "value": item.pers_id}
    ))

    const getAllInstitutions = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/institutions/", {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setInstitutions(res.data);
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;
                    } else if (res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    const getDepartments = (inst_id) => {

        if (inst_id !== "" && Number.isInteger(parseInt(inst_id))) {
            let headers = {"Content-Type": "application/json"};
            let token = localStorage.getItem("token");
            if (token) {
                headers["Authorization"] = `Token ${token}`;
                // //console.log("*** header: ***",headers);
                fetch(`/api/departmentbyinstitution/${inst_id}/`, {headers,})
                    .then(res => {
                        if (res.status < 500) {
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            // //console.log(res.data.departments);
                            const data = res.data.departments;
                            setDepartments(res.data.departments)
                            if (data.length > 0) {
                                getCities(data[0].coun_id);
                            }
                        } else if (res.status === 401 || res.status === 403) {
                            throw res.data;
                        }
                    })
            }
        }
    }

    const getCities = coun_id => {

        if (coun_id !== "" && Number.isInteger(parseInt(coun_id))) {
            let headers = {"Content-Type": "application/json"};
            let token = localStorage.getItem("token");
            if (token) {
                headers["Authorization"] = `Token ${token}`;
                // //console.log("*** header: ***",headers);
                fetch(`/api/cities/${coun_id}/`, {headers,})
                    .then(res => {
                        if (res.status < 500) {
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            setCities(res.data)
                        } else if (res.status === 401 || res.status === 403) {
                            throw res.data;
                        }
                    })
            }
        }
    }

    const getCountries = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch(`/api/countries/`, {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setCountries(res.data)
                    } else if (res.status === 401 || res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    const deptUpdateInitalize = (dept_id, dept_name, dept_detail, inst_id, city_id, coun_id) => {
        setDeptId(dept_id);
        setDeptName(dept_name);
        setDeptDetail(dept_detail);
        setInstId(inst_id);
        setCityId(city_id);
        setCounId(coun_id);
        setDeptUpdateDialogVisible(true);
        setDeptUpdateBtnVisible(true);
        setDeptAddBtnVisible(false)
        setDepartmentDisplay('block');
    }

    const showInstitutionDepartment = (inst_id, inst_name, inst_detail) => {
        getDepartments(inst_id);
        setInstId(inst_id);
        setInstName(inst_name);
        setInstDetail(inst_detail);
        setDeptUpdateBtnVisible(true);
        setDeptAddBtnVisible(false);
        setDepartmentDisplay('block');
    }

    const instUpdateInitalize = (rowData) => {
        setInstDetail(rowData.inst_detail);
        setInstName(rowData.inst_name);
        setInstId(rowData.inst_id);
        setInstUpdateDialogVisible(true);
        setInstUpdateBtnVisible(true);
        setInstAddBtnVisible(false);
    }

    const deptUpdate = () => {

        let data = {
            dept_name: dept_name,
            dept_detail: dept_detail,
            inst_id: inst_id,
            city_id: city_id
        };
        const url = dept_url + dept_id + '/';
        props.putMethod(data, url, update_dept_type);

    }

    const instUpdate = () => {
        let data = {
            inst_name: inst_name,
            inst_detail: inst_detail
        };
        const url = inst_url + inst_id + '/';
        props.putMethod(data, url, update_inst_type);

    }

    const deptAddInitalize = () => {
        setDeptId(null);
        setDeptName(null);
        setDeptDetail(null);
        setCityId(null);
        setDeptUpdateDialogVisible(true);
        setDeptAddBtnVisible(true);
        setDeptUpdateBtnVisible(false);
    }

    const instAddInitalize = () => {
        setInstName(null);
        setInstDetail(null);
        setInstId(null);
        setInstUpdateDialogVisible(true);
        setInstAddBtnVisible(true);
        setInstUpdateBtnVisible(false);
    }

    const deptAdd = () => {
        let data = {
            dept_name: dept_name,
            dept_detail: dept_detail,
            inst_id: inst_id,
            city_id: city_id
        };
        props.postMethod(data, dept_url, update_dept_type);
    }

    const instAdd = () => {
        let data = {
            inst_name: inst_name,
            inst_detail: inst_detail
        };
        props.postMethod(data, inst_url, inst_insert_type);
    }

    const deptActionTemplate = (rowData) => {
        return <div>
            <Button type="button"
                    icon="pi pi-pencil"
                    className="p-button-warning"
                    onClick={() => deptUpdateInitalize(rowData['dept_id'], rowData['dept_name'],
                        rowData['dept_detail'], rowData['inst_id'], rowData['city_id'], rowData['coun_id'])}
                    style={{marginRight: '.5em', maxHeight: '1.5em', maxWidth: '1.7em'}}>

            </Button>
            <InputSwitch
                checked={rowData['dept_flag_delete']}
                onChange={() => setDeptStatus(rowData)}
            />
        </div>;
    }

    const instActionTemplate = (rowData) => {
        return <div>
            {/*<Button type="button"*/}
            {/*        icon="pi pi-briefcase"*/}
            {/*        className="p-button-warning"*/}
            {/*        onClick={() => showInstitutionDepartment(rowData['inst_id'], rowData['inst_name'], rowData['inst_detail'])}*/}
            {/*        style={{marginRight: '.5em', maxHeight: '1.5em', maxWidth: '1.7em'}}>*/}

            {/*</Button>*/}
            <Button type="button"
                    icon="pi pi-pencil"
                    className="p-button-warning"
                    onClick={() => instUpdateInitalize(rowData)}
                    style={{marginRight: '.5em', maxHeight: '1.5em', maxWidth: '1.7em'}}>
            </Button>
            <InputSwitch
                checked={rowData['inst_flag_delete']}
                onChange={() => setInstStatus(rowData)}
            />
        </div>;
    }

    const setInstStatus = (rowData) => {
        let flag = rowData['inst_flag_delete'];
        let inst_id = rowData['inst_id'];
        let status_data = {};
        if (!flag) {
            rowData['inst_flag_delete'] = true;
            status_data = {
                inst_flag_delete: true
            };
        } else {
            rowData['inst_flag_delete'] = false;
            status_data = {
                inst_flag_delete: false
            };
            //this.props.updateLogStatus(id , status_data);
        }
        const url = inst_url + inst_id + '/';
        props.deleteMethod(status_data, url, delete_inst_type);
    }

    const setDeptStatus = (rowData) => {
        let flag = rowData['dept_flag_delete'];
        let dept_id = rowData['dept_id'];
        let status_data = {};
        if (!flag) {
            rowData['dept_flag_delete'] = true;
            status_data = {
                dept_flag_delete: true
            };
        } else {
            rowData['dept_flag_delete'] = false;
            status_data = {
                dept_flag_delete: false
            };
        }
        const url = dept_url + dept_id + '/';
        props.deleteMethod(status_data, url, delete_dept_type);
    }

    if (inst_list_role) {
        const instOptionItems = institutions.map((inst) => (
                {"label": inst.inst_name, "value": inst.inst_id}
            )
        );
        const cityOptionItems = cities.map((city) => (
                {"label": city.city_name, "value": city.city_id}
            )
        );
        const countryOptionItems = countries.map((country) => (
                {"label": country.coun_name, "value": country.coun_id}
            )
        );
        const dept_update_dialog_footer = (
            <div>
                {
                    dept_update_btn_visible ?
                        <Button
                            label="Güncelle"
                            icon="pi pi-check"
                            onClick={() => deptUpdate()}/>
                        : null}
                {
                    dept_add_btn_visible ?
                        <
                            Button
                            label="Ekle"
                            icon="pi pi-check"
                            onClick={() => deptAdd()}
                        />
                        : null}
                <Button
                    label="Vazgeç"
                    icon="pi pi-times"
                    // onClick={() => this.setState({dept_update_dialog_visible: false})}
                    className="p-button-secondary"/>
            </div>
        );
        const inst_update_dialog_footer = (
            <div>
                {
                    inst_update_btn_visible ?
                        <Button
                            label="Güncelle"
                            icon="pi pi-check"
                            onClick={() => instUpdate()}
                        />
                        : null}
                {
                    inst_add_btn_visible ?
                        <
                            Button
                            label="Ekle"
                            icon="pi pi-check"
                            onClick={() => instAdd()}
                        />
                        : null}
                <Button
                    label="Vazgeç"
                    icon="pi pi-times"
                    onClick={() => setInstUpdateDialogVisible(false)}
                    className="p-button-secondary"/>
            </div>
        );
        const dept_header = (
            <div style={{'textAlign': 'center'}}>
                {inst_name} Departmanları&nbsp;&nbsp;
                <Button icon="pi pi-plus-circle"
                        title="Departman Ekle"
                        style={{visibility: true ? 'visible' : 'hidden'}}
                        onClick={() => deptAddInitalize()}
                />
            </div>
        );
        const inst_header = (
            <div style={{'textAlign': 'center'}}>
                Kurumlar &nbsp;&nbsp;
                <Button icon="pi pi-plus-circle"
                        title="Kurum Ekle"
                        style={{visibility: true ? 'visible' : 'hidden'}}
                        onClick={() => instAddInitalize()}
                />
            </div>
        );
        const showSuccess = (message) => {
            toast.current.show({severity: 'success', summary: message, life: 3000});
        }

        const showError = (message) => {
            toast.current.show({
                severity: 'error',
                summary: message,
                life: 3000
            });
        }
        const postInstution = () => {
            const token = localStorage.getItem("token");
            const headers = {"Authorization": "Token " + token}
            const obj = {
                personInstID: personInstID
            };
            if (personInstID !== null) {
                axios.post('/api/add_person_instution/', obj, {"headers": headers})
                    .then(res => {
                        const data = res.data;
                        if (data.result) {
                            showSuccess(data.message)
                            getAllInstitutions()
                            getPersonIntsution()
                            setPersonInstID('')
                        } else {
                            showError(data.message)
                            getAllInstitutions()
                        }
                    })

            } else {
                showError("Kurum seçimi yapmadan ekleme işlemi gerçekleştiremezsiniz !")
            }
        }

        const instutionTemplate = () => {

            return (
                <div align="center">

                    <h5><b>Kullanıcıların Girdikleri Kurumları Sisteme Ekle</b>
                    </h5>


                </div>
            )
        }

        return (
            <div>
                <Toast ref={toast}/>
                <div className="p-grid">
                    <div className="p-col-12" align="center">
                        <Panel toggleable header={instutionTemplate}>
                            <div className="p-grid">
                                <div className="p-col-12">
                                    <MultiSelect value={personInstID} options={personInstutionsItems}
                                                 onChange={(e) => setPersonInstID(e.target.value)}
                                                 placeholder="Kurumları Seçiniz"
                                                 style={{width: '60%'}}
                                                 emptyFilterMessage="Kayıt bulunamadı"
                                                 selectedItemsLabel="{0} kurum seçildi"
                                                 filter
                                    />
                                </div>
                                <div className="p-col-2" style={{marginInline: 'auto'}}>
                                    <Button label="Ekle" className="p-button-success"
                                            onClick={postInstution}
                                    />
                                </div>

                                <div>

                                </div>
                            </div>
                        </Panel>
                    </div>
                </div>
                <div className="content-section implementation">
                    <DataTable
                        value={institutions}
                        style={{marginTop: '30px'}}
                        filterBy="username"
                        selectionMode="single"
                        emptyMessage="Kayıt bulunamadı"
                        header={inst_header}
                        paginator={true}
                        rows={12}
                        responsive={true}>
                        <Column
                            field="inst_id"
                            style={{width: '10%', fontSize: '12px'}}
                            header="No"
                            sortable={true}
                            filter={true}
                        />
                        <Column
                            style={{fontSize: '12px'}}
                            field="inst_name"
                            filterMatchMode="contains"
                            header="Adı"
                            sortable={true}
                            filter={true}
                        />
                        <Column
                            style={{fontSize: '12px'}}
                            header="Açıklama"
                            filterMatchMode="contains"
                            field="inst_detail"
                            sortable={true}
                            filter={true}/>
                        <Column
                            body={instActionTemplate}
                            style={{textAlign: 'center', width: '12em'}}
                        />
                    </DataTable>
                    {/*</TabPanel>*/}

                    {/*<TabPanel header="Departmanlar" leftIcon="pi pi-home">*/}
                    <DataTable header={dept_header}
                               value={departments}
                               rowGroupMode="rowspan"
                               sortField="coun_name"
                               paginator={true}
                               rows={15}
                               editable={true}
                               responsive={true}
                               groupField="coun_name"
                               style={{marginTop: '30px', display: departmentDisplay}}
                               emptyMessage="Kayıt bulunamadı"
                    >
                        <Column
                            field="coun_name"
                            header="Ülke"
                            filterMatchMode="contains"
                            style={{width: '11%', fontSize: '12px'}}
                            sortable={true}
                            filter={true}
                        />
                        <Column
                            field="city_name"
                            header="İl"
                            filterMatchMode="contains"
                            style={{width: '11%', fontSize: '12px'}}
                            sortable={true}
                            filter={true}
                        />
                        <Column
                            style={{width: '10%', fontSize: '12px'}}
                            field="dept_id"
                            header="No"
                            sortable={true}
                            filter={true}
                        />
                        <Column
                            field="dept_name"
                            filterMatchMode="contains"
                            style={{fontSize: '12px', width: '20em'}}
                            header="Adı"
                            sortable={true}
                            filter={true}
                        />
                        <Column
                            style={{fontSize: '12px'}}
                            header="Açıklama"
                            filterMatchMode="contains"
                            field="dept_detail"
                            filter={true}/>
                        <Column
                            body={deptActionTemplate}
                            style={{textAlign: 'center', width: '9%'}}
                        />
                    </DataTable>
                    {/*</TabPanel>*/}

                    {/*</TabView>*/}
                    <div className="content-section implementation">
                        <Dialog
                            header="Departman"
                            visible={dept_update_dialog_visible}
                            style={{width: '40vw'}}
                            footer={dept_update_dialog_footer}
                            onHide={() => setInstUpdateDialogVisible(false)}
                            dismissableMask={true}
                            maximizable>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="input">Kurum</label>
                                </div>
                                <div className="p-col-12 p-md-10">
                                    <Dropdown
                                        options={instOptionItems}
                                        inputId="inst_id"
                                        name="inst_id"
                                        value={inst_id}
                                        onChange={(e) => setInstId(e.value)}
                                        style={{width: '50%'}}
                                        filter={true}
                                        showClear={true}
                                        required={true}
                                        placeholder="Kurum"/>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="input">Ülke</label>
                                </div>
                                <div className="p-col-12 p-md-10">
                                    <Dropdown
                                        options={countryOptionItems}
                                        inputId="coun_id"
                                        name="coun_id"
                                        value={coun_id}
                                        onChange={(e) => setCounId(e.value)}
                                        style={{width: '50%'}}
                                        filter={true}
                                        showClear={true}
                                        required={true}
                                        placeholder="Ülke"/>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="input">İl</label>
                                </div>
                                <div className="p-col-12 p-md-10">
                                    <Dropdown
                                        options={cityOptionItems}
                                        inputId="city_id"
                                        name="city_id"
                                        value={city_id}
                                        onChange={(e) => setCityId(e.value)}
                                        style={{width: '50%'}}
                                        filter={true}
                                        showClear={true}
                                        required={true}
                                        placeholder="İl"/>
                                </div>

                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="input">Departman Adı</label>
                                </div>
                                <div className="p-col-12 p-md-10">
                                    <InputText
                                        id="dept_name"
                                        value={dept_name}
                                        onChange={(e) => setDeptName(e.target.value)}
                                        style={{width: '50%'}}
                                        name="dept_name"/>
                                </div>

                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="input">Açıklama</label>
                                </div>
                                <div className="p-col-12 p-md-10">
                                    <InputTextarea
                                        id="dept_detail"
                                        value={dept_detail}
                                        onChange={(e) => setDeptDetail(e.target.value)}
                                        name="dept_detail"
                                        rows={4}
                                        cols={30}>
                                    </InputTextarea>
                                </div>
                            </div>
                        </Dialog>
                    </div>
                    {/*enstitu*/}
                    <div className="content-section implementation">
                        <Dialog header="Kurum"
                                visible={inst_update_dialog_visible}
                                style={{width: '40vw'}}
                                footer={inst_update_dialog_footer}
                                onHide={() => setInstUpdateDialogVisible(false)}
                         dismissableMask={true}
                        maximizable>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-2">
                                <label htmlFor="input">Kurum Adı</label>
                            </div>
                            <div className="p-col-12 p-md-10">
                                <InputText id="inst_name"
                                           value={inst_name}
                                           onChange={(e) => setInstName(e.target.value)}
                                           style={{width: '50%'}}
                                           name="inst_name"/>
                            </div>

                            <div className="p-col-12 p-md-2">
                                <label htmlFor="input">Açıklama</label>
                            </div>
                            <div className="p-col-12 p-md-10">
                                <InputTextarea
                                    id="inst_detail"
                                    value={inst_detail}
                                    onChange={(e) => setInstDetail(e.target.value)}
                                    name="inst_detail"
                                    rows={4}
                                    cols={30}>
                                </InputTextarea>
                            </div>
                        </div>
                    </Dialog>
                </div>
            </div>
    </div>
    )
        ;
    } else {
        return (
            window.location.hash = "/notfound"
        )
    }

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
        return {
            putMethod: (data, url, type) => {
                return dispatch(management.putMethod(data, url, type));
            },
            postMethod: (data, url, type) => {
                return dispatch(management.postMethod(data, url, type));
            },
            deleteMethod: (data, url, type) => {
                return dispatch(management.deleteMethod(data, url, type));
            },
            logout: () => dispatch(auth.logout()),

            loadUser: () => {
                return dispatch(auth.loadUser());
            },
        }
    }
;


export default connect(mapStateToProps, mapDispatchToProps)(Inst_Dept);


// WEBPACK FOOTER //
// ./src/pages/userpages/Inst_Dept.jsx